// extracted by mini-css-extract-plugin
module.exports = {"imageAndDescription":"ImageAndDescription_imageAndDescription__EFzUM","description":"ImageAndDescription_description__Avjry","image":"ImageAndDescription_image__dliUI"};